import "apps/pathways/styles/components/pending.scss";
import React from 'react';
import PropTypes from 'prop-types';
import Cache from 'library/util/cache';
import Header from 'apps/pathways/components/header';
import Progress from 'library/components/progress';
import Pathway from 'apps/pathways/services/pathway';
import Query from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const Wait = (timeout) => new Promise((resolve) => {
    setTimeout(resolve, timeout);
})

const GenerateAndCacheRandomData = async () => {
    return await Pathway.create();
}

class Pending extends React.Component {
    static contextTypes = {
        reloadUser: PropTypes.func
    }

    constructor(...params) {
        super(...params);

        this.state = {
            progress: 10
        }
    }

    tick = async () => {
        await Wait(500);
        const { data } = await Query(`
            {
              account {
                opportunity_pathway {
                  built
                  difficulty
                  id
                  length
                  readiness
                  steps {
                    data
                    id
                    title
                    type
                    goal

                    courses {
                      link_name,
                      title,
                      characteristic {
                        name,
                        link_name
                      }
                    }
                    readiness {
                      score
                      education {
                        score
                        requirement
                        current
                      }
                      soft_skills {
                        score
                        requirement
                        current
                      }
                      hard_skills {
                        score
                        requirement
                        current
                      }
                    }
                  }
                }
              }
            }
        `)

        if (resolve(data, 'account.opportunity_pathway.built', false, '.')) {
            return this.setState({
                progress: 100
            }, async () => {
                await Cache.set('pathway-pending', false, __APPNAME__);
                await Cache.set('pathway_data', data.account.opportunity_pathway, 'pairin-pathways', 300);
                this.setState({
                  progress: 100
                });

                await this.context.reloadUser(false);

                setTimeout(()=>{
                  this.props.onLoaded(true, true)
                }, 200);
            })
        }

        this.setState((nextState) => {
            nextState.progress += 5;
            return nextState;
        }, this.tick);
    }

    componentDidMount() {
        this.tick();
    }

    render() {
        return (
            <div className={`pathways-pending`}>
                <div className="pathways-pending-container">
                    <Progress progress={this.state.progress} />
                    <h2>Calculating Your Career Pathway</h2>
                </div>
            </div>
        )
    }
}

export default Pending;
